module.exports = __webpack_public_path__ + "img/Display for IOT-01.cc089077.png";